import React from 'react';
import { useState, useEffect } from "react";

const Lightbox = ({
    isOpen: controlledIsOpen,    // optional controlled prop
    onClose,                     // callback for parent
    children
  }) => {
    const [internalOpen, setInternalOpen] = useState(false);

    const isControlled = controlledIsOpen !== undefined;
    const isOpen = isControlled ? controlledIsOpen : internalOpen;
    
    /**
     * Close the modal and stop click propagation. Needed because the closeModal must occur after the e.stopPropagation().
     * 
     * @param {Event} e usually a click event 
     */
    const stopClickPropagationWithClose = (e) => {
        e.stopPropagation();
        closeModal();
    };

    /**
     * Stop click propagation.
     * 
     * @param {Event} e usually a click event 
     */
    const stopClickPropagation = (e) => {
        e.stopPropagation();
    };

    const closeModal = () => {
        if (isControlled && onClose) {
          onClose();
        } else {
          setInternalOpen(false);
        }
    };

    useEffect(() => {
        setInternalOpen(false);
    }, []);


    return (
        isOpen && (
          <div
            className={`lightbox-overlay visible`}
            onClick={stopClickPropagationWithClose}
          >
            <div className="lightbox-content" onClick={stopClickPropagation}>
              {children}
              <div onClick={closeModal} className="x">X</div>
            </div>
          </div>
        )
    );
};

export default Lightbox;